import { render, staticRenderFns } from "./showPhoneNumber.vue?vue&type=template&id=0bb51681&scoped=true&"
import script from "./showPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./showPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./showPhoneNumber.vue?vue&type=style&index=0&id=0bb51681&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb51681",
  null
  
)

export default component.exports